// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTabbedPageView-ContentBody_cls1__Bovpe","cls2":"VeloTabbedPageView-ContentBody_cls2__gcqhv VeloTabbedPageView-ContentBody_cls1__Bovpe"};